/* LABOSCH V28 — desktop mega menus are hover/focus driven and mutually exclusive. */
(function(){
  'use strict';

  var mq = window.matchMedia('(min-width: 1025px)');
  var closeDelay = 120;
  var timers = new WeakMap();

  function desktop(){ return mq.matches; }

  function getMenus(root){
    return Array.prototype.slice.call((root || document).querySelectorAll(
      '.mg2-curated-catalog, .mg2-curated-brands, .mg2-curated-company'
    ));
  }

  function clearTimer(menu){
    var t = timers.get(menu);
    if(t){ window.clearTimeout(t); timers.delete(menu); }
  }

  function closeMenu(menu){
    clearTimer(menu);
    menu.removeAttribute('open');
    var summary = menu.querySelector(':scope > summary');
    if(summary) summary.setAttribute('aria-expanded','false');
  }

  function closeAll(root, except){
    getMenus(root).forEach(function(menu){ if(menu !== except) closeMenu(menu); });
  }

  function openMenu(root, menu){
    if(!desktop()) return;
    clearTimer(menu);
    closeAll(root, menu);
    menu.setAttribute('open','');
    var summary = menu.querySelector(':scope > summary');
    if(summary) summary.setAttribute('aria-expanded','true');
  }

  function scheduleClose(menu){
    clearTimer(menu);
    timers.set(menu, window.setTimeout(function(){
      if(!menu.matches(':hover') && !menu.contains(document.activeElement)) closeMenu(menu);
    }, closeDelay));
  }

  function boot(header){
    if(!header || header.dataset.lbxV28HoverReady === 'true') return;
    header.dataset.lbxV28HoverReady = 'true';

    var nav = header.querySelector('.mg2-curated');
    if(!nav) return;
    var menus = getMenus(nav);

    menus.forEach(function(menu){
      menu.setAttribute('data-lbx-hover-menu','');
      var summary = menu.querySelector(':scope > summary');
      if(summary) summary.setAttribute('aria-expanded', menu.hasAttribute('open') ? 'true' : 'false');

      menu.addEventListener('mouseenter', function(){ openMenu(nav, menu); });
      menu.addEventListener('mouseleave', function(){ if(desktop()) scheduleClose(menu); });
      menu.addEventListener('focusin', function(){ openMenu(nav, menu); });
      menu.addEventListener('focusout', function(){ if(desktop()) scheduleClose(menu); });

      if(summary){
        summary.addEventListener('click', function(event){
          if(!desktop()) return;
          /* Mouse/touchpad clicks no longer control desktop menus. Keyboard activation remains a fallback. */
          if(event.detail > 0){
            event.preventDefault();
            openMenu(nav, menu);
          }
        });
      }
    });

    nav.querySelectorAll('.mg2-curated__main > a, .mg2-curated__actions > a').forEach(function(link){
      link.addEventListener('mouseenter', function(){ if(desktop()) closeAll(nav); });
      link.addEventListener('focusin', function(){ if(desktop()) closeAll(nav); });
    });

    nav.addEventListener('mouseleave', function(){
      if(!desktop()) return;
      menus.forEach(scheduleClose);
    });

    header.addEventListener('keydown', function(event){
      if(event.key !== 'Escape' || !desktop()) return;
      var open = menus.find(function(menu){ return menu.hasAttribute('open'); });
      if(open){
        var summary = open.querySelector(':scope > summary');
        closeAll(nav);
        if(summary) summary.focus();
      }
    });

    function reset(){ closeAll(nav); }
    if(mq.addEventListener) mq.addEventListener('change', reset);
    else if(mq.addListener) mq.addListener(reset);
  }

  function init(){ document.querySelectorAll('[data-mg2-header]').forEach(boot); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();
